import {closePopup2} from "utils/CommonUtils";
import "styles/popup/popup.scss";

const MessagePopup = ({text}) => {
  return (
    <div className="newStyle">
      <section id="messagePopup" className="messagePopup popupContainer d-flex a-center j-center d-none">
        <div className="messagePopupBody bc-FF">
          <div className="title d-flex a-center j-center mb-20 fs-20 fw-5">
            {text}
          </div>
          <button
            className="barBtn bc-0764A9 fc-FF fs-18 fw-7"
            onClick={() => closePopup2("messagePopup")}
          >
            닫기
          </button>
        </div>
      </section>
    </div>
  );
};

export default MessagePopup;